export default class RotatingProduct {
  constructor(wrapper, imgs, loader) {
    this.wrapper = wrapper;
    this.imgs = imgs;
    this.loader = loader ? loader : false;
    this.loaded = 0;
    this.mouseDown = false;
    this.currentIndex = 0;
    this.lastIndex = 0;
    // this.lastIndex = Math.round((imgs.length - 1) / 2) // start from middle;
    
    this.init();
  }
  init() {
    // console.log('RotatingProduct init');
    this.wrapper.classList.add('loading');
    this.imgs.forEach(img => {
      img.addEventListener('load', event => {
        this.progressLoading();
      });
      img.srcset = img.dataset.srcset;
    });
  }
  progressLoading() {
    this.loaded++;
    if (this.loader) this.loader.innerText = `${Math.round(this.loaded / this.imgs.length * 100)}%`;
    if (this.loaded !== this.imgs.length) return;
    this.wrapper.classList.remove('loading');
    this.wrapper.classList.add('loaded');
    this.start();
  }
  start() {
    // console.log('RotatingProduct start');

    // this.changePhoto(this.lastIndex);
    let index = 0;
    let intervalID = setInterval(() => {
      if (index < this.imgs.length) {
        this.changePhoto(index);
        index++;
      }
      else {
        clearInterval(intervalID)
        this.bindEvents();
      }
    }, 50);
  }
	bindEvents() {
    this.wrapper.addEventListener('touchstart', event => {
      // if (event.touches.length < 2) return;
      event.preventDefault();
      this.handleInteractStart(event.touches[0].clientX);
    });
    this.wrapper.addEventListener('mousedown', event => {
      this.handleInteractStart(event.clientX);
    });
    document.addEventListener('touchend', event => {
      this.handleInteractEnd();
    });
    document.addEventListener('mouseup', event => {
      this.handleInteractEnd();
    });
    document.addEventListener('touchmove', event => {
      // if (event.touches.length < 2) return;
      this.handleInteractMove(event.touches[0].clientX);
    });
    document.addEventListener('mousemove', event => {
      event.preventDefault();
      this.handleInteractMove(event.clientX);
    });
  }
  handleInteractStart(posX) {
    this.mouseDown = true;
    this.startX = posX;
    this.wrapper.classList.add('grabbing');
  }
  handleInteractMove(posX) {
    if (! this.mouseDown) return;
    this.rotate(posX);
  }
  handleInteractEnd() {
    if (! this.mouseDown) return;
    this.mouseDown = false;
    this.wrapper.classList.remove('grabbing');
    this.lastRotationX = this.currentRotationX;
    this.lastIndex = this.currentIndex;
  }
  rotate(currentX) {
    let moveX = currentX - this.startX;
    // let newRotationX = Math.round(180 * (moveX / (this.wrapper.offsetWidth / 2)));
    let imgIndex = this.lastIndex + Math.round(moveX / this.wrapper.offsetWidth * this.imgs.length);
    let multiple = Math.floor(imgIndex / this.imgs.length);
    imgIndex = imgIndex - this.imgs.length * multiple;
    
    // console.log(imgIndex);
    this.currentIndex = imgIndex;
    this.changePhoto(imgIndex);
  }
  changePhoto(photoIndex) {
    this.imgs.forEach((img, index) => {
      if (index === photoIndex) img.classList.add('is-active');
      else img.classList.remove('is-active');
    });
  }
}
